import { fixedUi } from '@/i18n/fixedUi';
import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import BatchQueryModal from '@/shein-platform/modules/products/components/BatchQueryModal';
import {
  joinBatchTokens,
  BATCH_QUERY_LIMIT,
} from '@/shein-platform/modules/products/components/batchQueryUtils';

/**
 * 通用文本批量查询：标签 + 输入（逗号批量）+「+」弹窗。
 * 用于自动规则「规则名称 / 产品名称」等筛选。
 */
export default function SheinTextBatchFilter({
  value = '',
  disabled = false,
  onChange,
  onEnter,
  className = '',
  label = fixedUi("关键词"),
  placeholder = '支持逗号批量',
  fieldClassName = '',
}) {
  const [batchOpen, setBatchOpen] = useState(false);

  return (
    <>
      <div
        className={[
          'spo-field spo-field--inline spo-field--batch',
          fieldClassName,
          className,
        ].filter(Boolean).join(' ')}
      >
        <span className="spo-field__label">{label}</span>
        <input
          className="spo-input"
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onEnter?.();
          }}
        />
        <button
          type="button"
          className="spo-batch-add-btn"
          disabled={disabled}
          aria-label={`批量输入${label}`}
          title={fixedUi("批量查询")}
          onClick={() => setBatchOpen(true)}
        >
          <Plus size={16} strokeWidth={2.25} aria-hidden="true" />
        </button>
      </div>
      <BatchQueryModal
        open={batchOpen}
        title={`批量查询${label}`}
        initialValue={value}
        placeholder={`每行一个${label}，或用逗号分隔；最多 ${BATCH_QUERY_LIMIT} 条`}
        onClose={() => setBatchOpen(false)}
        onConfirm={(tokens) => {
          onChange?.(joinBatchTokens(tokens.slice(0, BATCH_QUERY_LIMIT)));
        }}
      />
    </>
  );
}
